module.exports = __webpack_public_path__ + "static/img/activity2.f93d4b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/aboutWe/activity2.jpg
// module id = TJYU
// module chunks = 3